import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_DELIVEROO_SYNC_LOG = 'deliverooSyncFilters'

const DeliverooSyncLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_DELIVEROO_SYNC_LOG)

  const syncTypeOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'syncType', [
        'catalogue',
        'price',
        'inventory',
        'listing',
      ]),
    [filterMeta],
  )

  const statusOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'status', [
        'in_progress',
        'sent',
        'error',
        'completed_success',
        'completed_fail',
      ]),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="syncType"
          label="Sync Type"
          options={syncTypeOptions}
          defaultValue={filters.syncType || ''}
          setValue={(_field: string, value: string) =>
            setField('syncType', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <FilterTextInput
        label="Store ID"
        value={filters.storeId || ''}
        onApply={(value) => setField('storeId', value)}
      />

      <FilterTextInput
        label="Upload ID"
        value={filters.uploadId || ''}
        onApply={(value) => setField('uploadId', value)}
      />

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default DeliverooSyncLogFilterForm
